module.exports = __webpack_public_path__ + "img/sk.3d182239.jpg";